module.exports = __webpack_public_path__ + "static/media/backspace.b111bf81.svg";